export const nftmarketaddress = "0x2eaAc0D9c07f767854dFbcaeEcaA8A615345AE92"
export const nftaddress = "0xE3Ff05d953AC3BBa16c01002b4178cA0662E09B0"